/**
 * Quiz Product Finder — Tag-basiertes 3-Fragen-Quiz
 *
 * Matching-Logik:
 *   - Brühmethode (Q1):  MUSS (AND)
 *   - Geschmack   (Q2):  mind. 1 muss matchen (OR)
 *   - Intensität  (Q3):  MUSS (AND)
 *
 * Fallback (Brühmethode wird ignoriert):
 *   1) Kräftigkeit + meiste Geschmacks-Übereinstimmungen
 *   2) Nur Kräftigkeit
 *   3) Zeige Top-N aus Basis-Collection
 */
(function () {
  'use strict';

  /* ── Central Tag Mapping (Dokumentation + Debug) ── */
  var TAG_MAP = {
    brew: {
      'Siebträger':          'brew:siebtraeger',
      'Vollautomat':         'brew:vollautomat',
      'Filterkaffeemaschine':'brew:filterkaffeemaschine',
      'Bialetti':            'brew:bialetti',
      'Aeropress':           'brew:aeropress',
      'Handfilter':          'brew:handfilter',
      'French Press':        'brew:frenchpress',
      'Chemex':              'brew:chemex'
    },
    taste: {
      'Fruchtig':      'taste:fruchtig',
      'Säurebetont':   'taste:saeurebetont',
      'Erdig':         'taste:erdig',
      'Schokoladig':   'taste:schokoladig',
      'Karamellnoten': 'taste:karamellnoten',
      'Blumig':        'taste:blumig',
      'Würzig':        'taste:wuerzig',
      'Nussig':        'taste:nussig',
      'Beerig':        'taste:beerig'
    },
    intensity: {
      'Kräftig':       'intensity:kraeftig',
      'Mittelkräftig': 'intensity:mittelkraeftig',
      'Mild':          'intensity:mild'
    }
  };

  /* ── Quiz Class ── */
  function QuizProductFinder(el) {
    this.el          = el;
    this.sectionId   = el.dataset.sectionId;
    this.resultsLimit = parseInt(el.dataset.resultsLimit, 10) || 8;
    this.noResultsText = el.dataset.noResultsText || '';
    this.debug       = el.dataset.debug === 'true';

    this.currentStep = 1;
    this.state       = { brew: null, tastes: new Set(), intensity: null };
    this.products    = [];

    // DOM refs
    this.steps         = el.querySelectorAll('.quiz-pf__step');
    this.stepDots      = el.querySelectorAll('.quiz-pf__step-dot');
    this.stepConnectors = el.querySelectorAll('.quiz-pf__step-connector');
    this.progressText  = el.querySelector('[data-current-step]');
    this.progressEl    = el.querySelector('.quiz-pf__progress');
    this.debugEl       = el.querySelector('.quiz-pf__debug');
    this.resultsGrid   = el.querySelector('.quiz-pf__results-grid');
    this.resultsCount  = el.querySelector('.quiz-pf__results-count');
    this.resultsHint   = el.querySelector('.quiz-pf__results-hint');
    this.cards         = el.querySelectorAll('.quiz-pf__card');

    this._init();
  }

  QuizProductFinder.prototype = {

    /* ── Init ── */
    _init: function () {
      this._loadProducts();
      this._bindEvents();
      this._updateUI();
    },

    _loadProducts: function () {
      var jsonEl = document.querySelector('[data-quiz-products="' + this.sectionId + '"]');
      if (!jsonEl) return;
      try {
        this.products = JSON.parse(jsonEl.textContent);
      } catch (e) {
        console.error('Quiz: could not parse product JSON', e);
      }
    },

    _bindEvents: function () {
      var self = this;

      // Option tiles
      this.el.querySelectorAll('.quiz-pf__option').forEach(function (btn) {
        btn.addEventListener('click', function () { self._handleOptionClick(btn); });
      });

      // Next
      this.el.querySelectorAll('[data-next]').forEach(function (btn) {
        btn.addEventListener('click', function () { self._goNext(); });
      });

      // Back
      this.el.querySelectorAll('[data-back]').forEach(function (btn) {
        btn.addEventListener('click', function () { self._goBack(); });
      });

      // Restart
      this.el.querySelectorAll('[data-restart]').forEach(function (btn) {
        btn.addEventListener('click', function () { self._restart(); });
      });
    },

    /* ── Option selection ── */
    _handleOptionClick: function (btn) {
      var type  = btn.closest('.quiz-pf__options').dataset.type;
      var value = btn.dataset.value;

      if (type === 'single') {
        // Deselect siblings
        btn.closest('.quiz-pf__options').querySelectorAll('.quiz-pf__option').forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-checked', 'true');

        if (this.currentStep === 1) this.state.brew = value;
        else if (this.currentStep === 3) this.state.intensity = value;

        // Auto-advance for single-select steps
        var self2 = this;
        setTimeout(function () { self2._goNext(); }, 250);

      } else {
        // Multi-select toggle
        if (btn.classList.contains('is-selected')) {
          btn.classList.remove('is-selected');
          btn.setAttribute('aria-checked', 'false');
          this.state.tastes.delete(value);
        } else {
          btn.classList.add('is-selected');
          btn.setAttribute('aria-checked', 'true');
          this.state.tastes.add(value);
        }
      }

      this._updateUI();
    },

    /* ── Validation ── */
    _isStepValid: function (step) {
      if (step === 1) return !!this.state.brew;
      if (step === 2) return this.state.tastes.size >= 1;
      if (step === 3) return !!this.state.intensity;
      return false;
    },

    /* ── Navigation ── */
    _goToStep: function (step) {
      // Remember position of quiz container relative to viewport
      var rect = this.el.getBoundingClientRect();
      var offsetBefore = rect.top;

      // Hide all steps
      this.steps.forEach(function (s) { s.classList.remove('is-active'); });

      // Show target
      var sel = step === 'results'
        ? '.quiz-pf__step[data-step="results"]'
        : '.quiz-pf__step[data-step="' + step + '"]';
      var target = this.el.querySelector(sel);
      if (target) target.classList.add('is-active');

      if (step !== 'results') this.currentStep = step;

      // Hide progress indicator on results to save space
      if (this.progressEl) {
        this.progressEl.style.display = (step === 'results') ? 'none' : '';
      }

      this._updateProgress(step);

      // Restore scroll so the quiz container stays at the same viewport position
      var rectAfter = this.el.getBoundingClientRect();
      var drift = rectAfter.top - offsetBefore;
      if (Math.abs(drift) > 1) {
        window.scrollBy(0, drift);
      }
    },

    _goNext: function () {
      if (!this._isStepValid(this.currentStep)) return;

      if (this.currentStep < 3) {
        this._goToStep(this.currentStep + 1);
        this._updateUI();
      } else {
        this._showResults();
        this._goToStep('results');
      }
    },

    _goBack: function () {
      if (this.currentStep > 1) {
        this._goToStep(this.currentStep - 1);
        this._updateUI();
      }
    },

    _restart: function () {
      this.currentStep = 1;
      this.state = { brew: null, tastes: new Set(), intensity: null };

      // Deselect all
      this.el.querySelectorAll('.quiz-pf__option').forEach(function (btn) {
        btn.classList.remove('is-selected');
        btn.setAttribute('aria-checked', 'false');
      });

      // Hide all product cards
      this.cards.forEach(function (card) {
        card.style.display = 'none';
        card.style.order = '';
      });

      this._goToStep(1);
      this._updateUI();
    },

    /* ── Progress indicator ── */
    _updateProgress: function (step) {
      var num = (step === 'results') ? 4 : step;

      // Update step dots
      this.stepDots.forEach(function (dot) {
        var dotNum = parseInt(dot.dataset.dot, 10);
        dot.classList.remove('is-active', 'is-done');
        if (dotNum < num) {
          dot.classList.add('is-done');
          dot.textContent = '✓';
        } else if (dotNum === num) {
          dot.classList.add('is-active');
          dot.textContent = dotNum;
        } else {
          dot.textContent = dotNum;
        }
      });

      // Update connectors
      this.stepConnectors.forEach(function (conn) {
        var connNum = parseInt(conn.dataset.connector, 10);
        conn.classList.toggle('is-done', connNum < num);
      });

      if (this.progressText) {
        this.progressText.textContent = (step === 'results') ? '✓' : num;
      }
    },

    /* ── Next-button state ── */
    _updateUI: function () {
      var stepEl = this.el.querySelector('.quiz-pf__step[data-step="' + this.currentStep + '"]');
      if (stepEl) {
        var nextBtn = stepEl.querySelector('[data-next]');
        if (nextBtn) nextBtn.disabled = !this._isStepValid(this.currentStep);
      }
      this._updateDebug();
    },

    /* ── Matching ── */
    _getMatches: function () {
      var brew      = this.state.brew;
      var intensity = this.state.intensity;
      var tastes    = Array.from(this.state.tastes);
      var limit     = this.resultsLimit;

      if (!brew || !intensity || tastes.length === 0) {
        return { matches: [], fallback: 2 };
      }

      var brewLower      = brew.toLowerCase();
      var intensityLower = intensity.toLowerCase();
      var oneOf          = tastes.map(function (t) { return t.toLowerCase(); });

      // Helper: count taste matches for a product
      function countTasteMatches(p) {
        var tags = p.tags.map(function (t) { return t.toLowerCase(); });
        return oneOf.filter(function (o) { return tags.indexOf(o) !== -1; }).length;
      }

      // Full match: brew + intensity + at least one taste
      var matches = this.products.filter(function (p) {
        var tags = p.tags.map(function (t) { return t.toLowerCase(); });
        return tags.indexOf(brewLower) !== -1
            && tags.indexOf(intensityLower) !== -1
            && oneOf.some(function (o) { return tags.indexOf(o) !== -1; });
      });

      // Best-match sorting: more taste hits → higher rank
      matches.sort(function (a, b) {
        return countTasteMatches(b) - countTasteMatches(a);
      });

      if (matches.length > 0) return { matches: matches, fallback: 0 };

      // Fallback 1: ignore brew — intensity + most taste matches
      matches = this.products.filter(function (p) {
        var tags = p.tags.map(function (t) { return t.toLowerCase(); });
        return tags.indexOf(intensityLower) !== -1
            && oneOf.some(function (o) { return tags.indexOf(o) !== -1; });
      });
      matches.sort(function (a, b) {
        return countTasteMatches(b) - countTasteMatches(a);
      });
      if (matches.length > 0) return { matches: matches, fallback: 1 };

      // Fallback 2: only intensity (ignore brew and taste)
      matches = this.products.filter(function (p) {
        var tags = p.tags.map(function (t) { return t.toLowerCase(); });
        return tags.indexOf(intensityLower) !== -1;
      });
      if (matches.length > 0) return { matches: matches, fallback: 1 };

      // Fallback 3: show top N from collection
      return { matches: this.products.slice(0, limit), fallback: 2 };
    },

    /* ── Results rendering ── */
    _showResults: function () {
      var result  = this._getMatches();
      var limited = result.matches.slice(0, this.resultsLimit);
      var handleSet = {};
      limited.forEach(function (m) { handleSet[m.handle] = true; });

      // Show/hide cards + set order for best-match sorting
      this.cards.forEach(function (card) {
        var handle = card.dataset.productHandle;
        if (handleSet[handle]) {
          card.style.display = '';
          var idx = limited.findIndex(function (m) { return m.handle === handle; });
          card.style.order = idx >= 0 ? idx : 999;
        } else {
          card.style.display = 'none';
          card.style.order = '';
        }
      });

      // Result count & fallback messaging
      if (this.resultsCount) {
        if (result.fallback === 0) {
          var count = limited.length;
          this.resultsCount.textContent = count === 1
            ? '1 Kaffee gefunden'
            : count + ' Kaffees gefunden';
        } else {
          this.resultsCount.textContent = 'Leider konnten wir für Ihre Auswahl keine passenden Kaffees finden';
        }
      }

      // Fallback hint — show alternative suggestions subtitle
      if (this.resultsHint) {
        if (result.fallback > 0 && limited.length > 0) {
          this.resultsHint.textContent = 'Hier finden Sie Produkte, die Ihrer Auswahl am nächsten kommen:';
          this.resultsHint.style.display = '';
        } else {
          this.resultsHint.style.display = 'none';
        }
      }

      this._updateDebug();
    },

    /* ── Debug panel ── */
    _updateDebug: function () {
      if (!this.debug || !this.debugEl) return;

      var info = {
        step: this.currentStep,
        brew: this.state.brew,
        tastes: Array.from(this.state.tastes),
        intensity: this.state.intensity,
        totalProducts: this.products.length
      };

      if (this.state.brew && this.state.intensity && this.state.tastes.size > 0) {
        var result = this._getMatches();
        info.matchCount    = result.matches.length;
        info.fallbackLevel = result.fallback;
        info.shownHandles  = result.matches.slice(0, this.resultsLimit).map(function (m) { return m.handle; });
      }

      this.debugEl.textContent = JSON.stringify(info, null, 2);
    }
  };

  /* ── Bootstrap ── */
  function init() {
    document.querySelectorAll('.quiz-pf').forEach(function (el) {
      if (el.dataset.quizInit) return;
      el.dataset.quizInit = 'true';
      new QuizProductFinder(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
